import React from 'react'

import { arrayOf, shape, string, bool } from 'prop-types'

import AssetItem from 'Pods/UnifiedNavigation/Shared/AssetItem/AssetItem'

function BudgetList({ items, actionsConfig }) {
  if (!items?.length) {
    return null
  }

  const isSubscribed = actionsConfig?.isActiveSubscriber

  const filteredItems = items.filter((item) => {
    return !(item.icon === 'subscription' && item.withSub !== isSubscribed)
  })

  return (
    <div className="budget-list">
      {filteredItems.map((budget) => (
        <AssetItem
          key={budget.title}
          title={budget.title}
          icon={budget.icon}
          href={budget.path}
          showArrow={false}
          actionsConfig={actionsConfig}
        />
      ))}
    </div>
  )
}

BudgetList.propTypes = {
  items: arrayOf(shape({
    title: string.isRequired,
    path: string.isRequired,
    icon: string.isRequired,
    withSub: bool,
  })).isRequired,
  actionsConfig: shape({
    subscriptionMenuEnabled: bool,
    subscriptionFlowEnabled: bool,
    isActiveSubscriber: bool,
  }).isRequired,
}

export default BudgetList
